module.exports = __webpack_public_path__ + "static/media/deferred-debt-banner.cf376d83.png";